const $ = jQuery;

class ReturningUserNotYouClickedEvent {
	static getEventName () {
		return "returning-user-not-you-clicked";
	}

	trigger () {
		$(document).trigger(ReturningUserNotYouClickedEvent.getEventName());
	}

	static addListener (handle) {
		$(document).on(ReturningUserNotYouClickedEvent.getEventName(), () => {
			handle();
		});
	}
}
